import SpaceBetween from "@cloudscape-design/components/space-between";
import {
  Box,
  Table,
  Button,
  TextFilter,
  Pagination,
  CollectionPreferences,
  ColumnLayout,
  Container,
  Header,
  Link,
  StatusIndicator,
  AppLayout,
  BreadcrumbGroup,
  ContentLayout,
  HelpPanel,
  Icon,
  SplitPanel,
  Spinner,
} from "@cloudscape-design/components";

import Grid from "@cloudscape-design/components/grid";

import { useEffect, useState } from "react";

import { Amplify } from "aws-amplify";
import { generateClient } from "aws-amplify/api";
import config from "../../../amplifyconfiguration.json";
import TenantChart from "./components/TenantChart";
import VariationTable from "./components/ListTenant";
import { ListTenant } from "./data/data";
import { Navigation } from "../../../components/app/Navigation";
import React from "react";
import { listTenants } from "../../../graphql/queries";
import { ListTenantsQueryVariables } from "../../../API";
import StatusPayment from "./components/TenantPaymentChart";
//import ListTenant from "./components/ListTenant";


Amplify.configure(config);

function DashboardSystem() {
  const [total_tenant, updateTotal_tenant] = useState(0);
  const [total_basic, updateTotal_basic] = useState(0);
  const [total_silver, updateTotal_silver] = useState(0);
  const [total_gold, updateTotal_gold] = useState(0);
  const [total_paid, updateTotal_paid] = useState(0);
  const [total_unpaid, updateTotal_unpaid] = useState(0);
  const [activeHref, setActiveHref] = React.useState("/system");
  const [helpPanelOpen, setHelpPanelOpen] = useState(false); // State untuk mengontrol panel bantuan
  const [listTenant, setListTenant] = useState<ListTenant[]>([]);
  const [isLoading, setIsLoading] = React.useState(true);

  //graphql apis
  useEffect(() => {
    //currentAuthenticatedUser();
    fetchOverview();
  }, []);

  async function fetchOverview(limit=100) {
    try {
      const client = generateClient();
      let nextToken : string | null = null;
      let allTenants: ListTenant[]=[];
      let basic = 0;
      let silver = 0;
      let gold = 0;
      let paid = 0;
      let unpaid = 0;

      do{
      const variables:ListTenantsQueryVariables = {limit, nextToken};
      let response = await client.graphql({
        query: listTenants,
        authMode : 'userPool',
        variables, 
      });

      const tenants = response.data.listTenants.items;
      nextToken = response.data.listTenants.nextToken ?? null;

      const newTenants: ListTenant[] = tenants.map((tenant) => {
        const ServicePacakge = tenant["servicepackage"] ?? "";
        if (ServicePacakge === "Basic") {
          basic++;
        } else if (ServicePacakge === "Silver") {
          silver++;
        } else if (ServicePacakge === "Gold"){
          gold++;
        }

          return {
          id: tenant.id,
          TenantName: tenant.tenantname ?? "",
          Subtenant: tenant.subtenant ?? "",
          Address: tenant.address ?? "",
          Contact: tenant.contact  ?? "",
          Phone: tenant.phone ?? "",
          Status: tenant.status ?? "",
          ServicePacakge: ServicePacakge,
          StatusPayment: Boolean(tenant.statuspayment),
        }
       } );
      allTenants=[...allTenants, ...newTenants];
    } while (nextToken);

      setListTenant(allTenants);
      updateTotal_tenant(allTenants.length);
      updateTotal_basic(basic);
      updateTotal_silver(silver);
      updateTotal_gold(gold);
      setIsLoading(false);

    } catch (err) {
      console.log("error fetching todos : ", err);
    }
  }

  return (
    <>
      <AppLayout
        breadcrumbs={
          <BreadcrumbGroup
            items={[
              {
                text: "System",
                href: "/system/tenants",
              },
              {
                text: "Overview",
                href: "/system",
              },
            ]}
          />
        }
        navigation={
          <Navigation
            activeHref={activeHref}
            setActiveHref={setActiveHref}
            adminSubMenuOpen={false}
            setAdminSubMenuOpen={function (href: boolean): void {
              throw new Error("Function not implemented.");
            }} // adminSubMenuOpen={adminSubMenuOpen} // Mengirim state submenu Admin ke komponen Navigation
            // setAdminSubMenuOpen={setAdminSubMenuOpen} // Mengirim fungsi untuk mengubah state submenu Admin ke komponen Navigation
          />
        }
        //navigationOpen={true}
        //   navigation={
        //     <Navigation activeHref={activeHref} setActiveHref={setActiveHref} />
        //   }
        //notifications={
        //  <Flashbar
        //    items={[
        //      {
        //        type: "info",
        //        dismissible: true,
        //        content: "This is an info flash message.",
        //        id: "message_1",
        //      },
        //    ]}
        //  />
        //}
        toolsOpen={helpPanelOpen} // Menggunakan state untuk menentukan apakah panel bantuan terbuka atau tidak
        onToolsChange={() => setHelpPanelOpen(!helpPanelOpen)}
        tools={
          <HelpPanel
            footer={
              <div>
                <h3>
                  Learn more <Icon name='external' />
                </h3>
                <ul>
                  <li>
                    <a href=''>Link to documentation</a>
                  </li>
                  <li>
                    <a href=''>Link to documentation</a>
                  </li>
                </ul>
              </div>
            }
            header={<h2>Help panel title (h2)</h2>}
          >
            <div>
              <p>
                This is a paragraph with some <b>bold text</b> and also some{" "}
                <i>italic text</i>.
              </p>

              <h3>h3 section header</h3>
              <ul>
                <li>Unordered list item.</li>
                <li>Unordered list item.</li>
              </ul>

              <h4>h4 section header</h4>
              <p>
                Code can be formatted as lines of code or blocks of code. Add
                inline code <code>like this</code> using a{" "}
                <code>{"<code>"}</code> tag.
                <pre>
                  Or format blocks of code (like this) using a{" "}
                  <code>{"<pre>"}</code> tag.
                </pre>
              </p>

              <h5>h5 section header</h5>
              <dl>
                <dt>This is a term</dt>
                <dd>This is its description.</dd>
                <dt>This is a term</dt>
                <dd>This is its description</dd>
              </dl>
            </div>
          </HelpPanel>
        }
        content={
          <ContentLayout
            header={
              <Header
                variant='h1'
                info={
                  <Link
                    variant='info'
                    onFollow={() => setHelpPanelOpen(!helpPanelOpen)}
                  >
                    Info
                  </Link>
                }
              >
                {activeHref === "/system" ? `Dashboard Tenant ` : ""}
              </Header>
            }
          >
            <div className='contentPlaceholder'>
              <SpaceBetween size='l'>
                <Grid
                  gridDefinition={[
                    { colspan: { default: 12, xxs: 8 } },
                    { colspan: { default: 12, xxs: 4 } },
                    { colspan: { default: 12, xxs: 12 } },
                  ]}
                >
                  <Container
                    header={
                      <Header
                        variant='h2'
                        description='Summary of total tenants'
                      >
                        Overview
                      </Header>
                    }
                    fitHeight={true}
                  >
                    <ColumnLayout
                      columns={4}
                      variant='text-grid'
                      minColumnWidth={100}
                    >
                      <div>
                        <Box variant='awsui-key-label'>Total Tenants</Box>
                        <Link
                          variant='awsui-value-large'
                          href='#'
                          ariaLabel='Running instances (14)'
                        >
                          {total_tenant} 
                        </Link>
                      </div>
                      <div>
                        <Box variant='awsui-key-label'>Service Basic</Box>
                        <Link
                          variant='awsui-value-large'
                          href='#'
                          ariaLabel='Volumes (126)'
                        >
                          {total_basic}
                        </Link>
                      </div>
                      <div>
                        <Box variant='awsui-key-label'>Service Silver</Box>
                        <Link
                          variant='awsui-value-large'
                          href='#'
                          ariaLabel='Volumes (126)'
                        >
                          {total_silver}
                        </Link>
                      </div>
                      <div>
                        <Box variant='awsui-key-label'>Service Gold</Box>
                        <Link
                          variant='awsui-value-large'
                          href='#'
                          ariaLabel='Volumes (126)'
                        >
                          {total_gold}
                        </Link>
                      </div>
                    </ColumnLayout>
                  </Container>
                  <Container fitHeight={true}>
                  {isLoading ? (
                    
                    <Box textAlign='center' padding="xl">
                      <Spinner size='large' />
                      <Box variant='p'>Loading users data...</Box>
                    </Box>
                    
                  ) : (
                    <ColumnLayout columns={2} minColumnWidth={100}>              
                  <TenantChart ListTenant={listTenant} />             
                  <StatusPayment tenants={listTenant} />
                  </ColumnLayout>
                  )}
                  
                  </Container>

                  {isLoading ? (
                    <Box textAlign='center'>
                      <Spinner size='large' />
                      <Box variant='p'>Loading tenants data...</Box>
                    </Box>
                  ) : (
                    <VariationTable ListTenant={listTenant} />
                  )}
                  
                </Grid>
              </SpaceBetween>
            </div>
          </ContentLayout>      
          
        }
        splitPanel={
          <SplitPanel header='Split panel header'>
            Split panel content
          </SplitPanel>
        }
      />
    </>
  );
}

export default DashboardSystem;
